import { TranslateFunc } from 'components/translate/src/translate-func';
import { ClientMarket } from 'config/types/client-market';
import { FilterSelection } from 'src/components/price-list/types';
import { VariantValues } from '../types';

export const getSizeTitle = (t: TranslateFunc, market: ClientMarket) => {
  return `${t('product', 'label.size')} (${
    market.productVariants?.shoeSizeStandard
  })`;
};

export const createNewSelection = (
  variant: string | null,
  variantSelection: FilterSelection
) => {
  if (!variant) {
    return [];
  }
  return variantSelection.includes(variant)
    ? variantSelection.filter((v: string) => v !== variant)
    : [...variantSelection, variant];
};

export const getFractalRepresentation = (numericString: string) => {
  const integerValue = parseInt(numericString, 10);
  const decimalValue = parseFloat(numericString) % 1;
  if (isNaN(integerValue) || isNaN(decimalValue)) {
    return numericString;
  }
  if (decimalValue > 0.4 && decimalValue < 0.6) {
    return `${integerValue} ½`;
  }
  if (decimalValue > 0.25 && decimalValue < 0.4) {
    return `${integerValue} ⅓`;
  }
  if (decimalValue > 0.6 && decimalValue < 0.75) {
    return `${integerValue} ⅔`;
  }
  return numericString;
};

export const addSelectionToVariantValues = (
  variantValues: VariantValues,
  filterSelection: FilterSelection
): VariantValues => {
  const sizes = new Set<string>();
  variantValues.sizes.forEach(variant => {
    sizes.add(variant);
  });
  filterSelection.forEach(selection => {
    sizes.add(selection);
  });
  return { sizes: [...sizes] };
};
